import styled from 'styled-components';

export const StyledIntegrationSearch = styled.div`
  width: 18rem;

  .Polaris-TextField {
    --p-color-input-border: var(--p-color-border-secondary, #e3e3e3);
    --p-color-input-border-hover: var(--p-color-border-secondary, #e3e3e3);
  }

  .Polaris-TextField__Backdrop {
    border-top-color: var(--p-color-border-secondary, #e3e3e3);
  }
`;